/** @format */

import React, { useState, useCallback, useEffect, useMemo } from "react";
import "../../style/news.css";
import "../../style/channel.css";
import "../../style/survey.css";
import { Route, Routes, useNavigate, Navigate, useLocation } from "react-router-dom";
import { TabMenu } from "primereact/tabmenu";
import Subscription from "./Subscription";
import Commodities from "./Commodities";
import Mapping from "./Mapping";
import MerchantContacts from "./MerchantContacts";

function Channel(props) {
  const { isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isGrainsRole, isSuperAdminRole, isCornRole } = props;
  let navigate = useNavigate();
  let location = useLocation();

  let { pathname } = location;
  let menuItems = useMemo(
    () => [
      {
        label: "Subscription",
        path: "subscription",
        command: function () {
          navigate(this.path);
        },
      },
      {
        label: "Mapping",
        path: "mapping",
        command: function () {
          navigate(this.path);
        },
      },
      {
        label: "Merchant Contacts",
        path: "merchant-contacts",
        command: function () {
          navigate(this.path);
        },
      },
      {
        label: "Commodities",
        path: "commodities",
        command: function () {
          navigate(this.path);
        },
      },
    ],
    [navigate]
  );
  let [selectedMenuItem, setSelectedMenuItem] = useState(menuItems[0]);
  useEffect(() => {
    setSelectedMenuItem((prevMenuItems) => menuItems.findIndex((menuItem) => {
      let __pathname = pathname.split("channel/")[1];  
      return __pathname && __pathname.includes(menuItem.path);
    }));
  }, [pathname, menuItems]);

  const onTabChangeHandler = useCallback(
    (e) => {
      setSelectedMenuItem(e.index);
    },
    [setSelectedMenuItem]
  );

  return (
    <div className='main-box'>
      <div className='app__grid'>
        <React.Fragment>
          <TabMenu
            model={menuItems}
            activeIndex={selectedMenuItem}
            id='mi__tab__menu'
            className='mb-2'
            onTabChange={onTabChangeHandler}
          />
          <Routes>
            <Route
              path='subscription/*'
              element={
                <Subscription
                  isEdibleOilsRole={isEdibleOilsRole}
                  isCocoaRole={isCocoaRole}
                  isAnimalFeedRole={isAnimalFeedRole}
                  isSuperAdminRole={isSuperAdminRole}
                  isGrainsRole={isGrainsRole}
                  isCornRole={isCornRole}
                />
              }
            ></Route>
            <Route
              path='mapping'
              element={
                <Mapping
                  isEdibleOilsRole={isEdibleOilsRole}
                  isCocoaRole={isCocoaRole}
                  isAnimalFeedRole={isAnimalFeedRole}
                  isSuperAdminRole={isSuperAdminRole}
                  isGrainsRole={isGrainsRole}
                  isCornRole={isCornRole}
                />
              }
            ></Route>
            <Route
              path='merchant-contacts'
              element={
                <MerchantContacts
                  isEdibleOilsRole={isEdibleOilsRole}
                  isCocoaRole={isCocoaRole}
                  isAnimalFeedRole={isAnimalFeedRole}
                  isSuperAdminRole={isSuperAdminRole}
                  isGrainsRole={isGrainsRole}
                  isCornRole={isCornRole}
                />
              }
            ></Route>
            <Route
              path='commodities/*'
              element={<Commodities isCocoaRole={isCocoaRole} isSuperAdminRole={isSuperAdminRole} />}
            ></Route>
            <Route path='*' element={<Navigate to='subscription' replace />} />
          </Routes>
        </React.Fragment>
      </div>
    </div>
  );
}

export default Channel;
